module.exports = __webpack_public_path__ + "static/media/NAAAPTampa.3f32a4ea.jpg";